import React, { SVGProps } from "react";
export default function SupTextArea(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g clipPath="url(#clip0_5558_2882)">
        <path d="M20.9999 15.5147L15.7573 20.7573M20.9999 12.5147L12.5146 21" stroke="currentColor" />
      </g>
      <defs>
        <clipPath id="clip0_5558_2882">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
